(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    if (!window.__videoScrollFadeInit) {
  window.__videoScrollFadeInit = true;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const fadeEl = entry.target.__fadeEl || entry.target;
        fadeEl.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.video-scroll-fade').forEach((el) => {
    const target = el.querySelector('video-background-component') || el.closest('.section') || el;
    target.__fadeEl = el;
    io.observe(target);
  });
}
  } catch(e) { console.error(e); }
})();

})();
